import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../Common/Alert";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";
import ReactDataTable from "../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [onTest, setOnTest] = useState(false);
  const [role, setRole] = useState("");

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [statusValue, setStatusValue] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateAlert, setUpdateAlert] = useState(null);

  const fetchData = () => {
    Http.get("/staff-type-check").then((res) => {
      setRole(res.data);
      if (res.data == "sample") {
        setOnTest(true);
      }
    });
    Http.get("/gless-colour").then((res) => {
      setReceiveData(res.data);
      document.getElementById("app-title").innerText = `(0) Artisan ERP`;
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const markAsRead = (id) => {
    Http.get("/notifications/" + id + "/mark-as-read")
      .then((res) => {
        Swal.fire("Mark As Read!", "Mark As Read", "success");
        Http.get("/notifications").then((res) => {
          setReceiveData(res.data);
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  const deleteImage = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.get("/gless-colour-delete/" + id)
          .then((res) => {
            Swal.fire("Deleted!", "Gless Colour has been deleted.", "success");
            fetchData();
            navigate("/gless-colour");
          })
          .catch((error) => {
            Swal.fire(
              "Error!",
              "An error occurred while deleting the image.",
              "error"
            );
          });
      }
    });
  };
  const handleStatusSubmit = async (e) => {
    e.preventDefault();
    if (!selectedShape) return;

    setIsUpdating(true);
    try {
      const response = await Http.put(`/glaze/${selectedShape.id}`, {
        status: statusValue,
      });

      if (response.status === 200) {
        setUpdateAlert({
          type: "success",
          message: "Status updated successfully!",
        });

        // Update the local data
        setReceiveData((prevData) =>
          prevData.map((item) =>
            item.id === selectedShape.id
              ? { ...item, status: statusValue }
              : item
          )
        );

        // Close modal after a short delay
        setTimeout(() => {
          handleModalClose();
        }, 1500);
      }
    } catch (error) {
      console.error("Update error:", error);
      setUpdateAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to update status",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  function formatStatusText(text) {
    if (!text) return "";

    // Replace underscore with space
    let formatted = text.replace(/_/g, " ");

    // Make first word uppercase, keep the rest lowercase
    let parts = formatted.split(" ");

    return parts.join(" ");
  }

  // Handle modal open
  const handleStatusUpdate = (rowData) => {
    setSelectedShape(rowData);
    setStatusValue(rowData.status || "");
    setShowModal(true);
    setUpdateAlert(null);
  };

  // Handle modal close
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedShape(null);
    setStatusValue("");
    setUpdateAlert(null);
  };

  const cols = [
    { field: "colour_name", header: "Name" },
    { field: (rowData)=>{
      return formatStatusText(formatStatusText(rowData.status));
    }, header: " Status " },
    {
      field: (item) => (
        <div>
          {/* <Link
            to={`/edit-gless-colour/${item.id}`}
            className="btn btn-primary btn-sm me-2"
            title="Edit gless colour"
          >
            <i className="fa fa-edit"></i>
          </Link> */}
          {item.status == "on_test" && (
            <button
              className="btn btn-info btn-sm me-1"
              onClick={() => handleStatusUpdate(item)}
              title="Update Status"
            >
              <i className="fa fa-edit"></i>
            </button>
          )}

          <Link
            onClick={() => deleteImage(item.id)}
            className="btn btn-danger btn-sm"
            title="Trash gless colour"
          >
            <i className="fa fa-trash"></i>
          </Link>
        </div>
      ),
      header: "Action",
    },
  ];

  return (
    <>
      <IsLogin />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Glaze Colour</h5>
            <Link
              to="/create-gless-colour"
              className="btn btn-primary"
              title="Create gless colour"
            >
              <i className="fa fa-plus-square mg-r-6"></i>
              Create
            </Link>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                test={onTest}
                isLoading={loading}
              />
            </div>
          </div>

          {/* Status Update Modal */}
          {showModal && (
            <div
              className="modal fade show"
              style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Update Status</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleModalClose}
                      disabled={isUpdating}
                    ></button>
                  </div>
                  <form onSubmit={handleStatusSubmit}>
                    <div className="modal-body">
                      {updateAlert && (
                        <div
                          className={`alert alert-${
                            updateAlert.type === "success"
                              ? "success"
                              : "danger"
                          }`}
                        >
                          {updateAlert.message}
                        </div>
                      )}
                      <div className="mb-3">
                        <label htmlFor="statusInput" className="form-label">
                          Status
                        </label>
                        <select
                          id="statusInput"
                          className="form-select"
                          value={statusValue}
                          onChange={(e) => setStatusValue(e.target.value)}
                          required
                          disabled={isUpdating}
                        >
                          <option value="">Select Status</option>
                          <option value="active">Active</option>
                        </select>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleModalClose}
                        disabled={isUpdating}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isUpdating || !statusValue}
                      >
                        {isUpdating ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Updating...
                          </>
                        ) : (
                          "Update Status"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default List;
